import produce from "immer";
import { ActionsQueueReducerActions, ActionsQueueReducerState } from "./types";

export const initialState: ActionsQueueReducerState = {
  actionsQueue: {},
};

const contextReducer = (
  state = initialState,
  action: ActionsQueueReducerActions
): ActionsQueueReducerState => {
  switch (action.type) {
    case "REMOVE_ACTIONS_FROM_QUEUE": {
      const updatedQueue = produce(state.actionsQueue, (draft) => {
        const { idsToRemove } = action;
        idsToRemove.forEach((key) => {
          delete draft[key];
        });
      });

      return {
        actionsQueue: updatedQueue,
      };
    }
    case "UPDATE_ACTIONS_QUEUE": {
      const updatedQueue = produce(state.actionsQueue, (draft) => {
        const { actionKey, actionValue } = action;
        draft[actionKey] = actionValue;
      });

      return {
        actionsQueue: updatedQueue,
      };
    }

    default:
      return state;
  }
};

export default contextReducer;
